import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Modal from '../ui/modal';
const NotImplementedContext = React.createContext({
    showNotImplemented: () => { },
    hideNotImplemented: () => { }
});
export const useNotImplemented = () => React.useContext(NotImplementedContext);
const NotImplementedProvider = ({ children }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const contextValue = {
        showNotImplemented: () => setIsOpen(true),
        hideNotImplemented: () => setIsOpen(false)
    };
    return (_jsxs(NotImplementedContext.Provider, { value: contextValue, children: [children, _jsxs(Modal, { id: "not-implemented-modal", title: "Under Construction", isOpen: isOpen, onClose: contextValue.hideNotImplemented, children: [_jsx("h3", { children: "\uD83D\uDC35 Under construction!" }), _jsx("p", { children: "Our coding monkeys are on the job, powered by bananas, curiosity, and questionable commit messages. Check back soon." })] })] }));
};
export default NotImplementedProvider;
